/**
 * Canonical site configuration. SITE_URL drives every absolute URL we emit
 * (canonical, Open Graph, sitemap). Override it at build time with the SITE_URL
 * env var for preview deploys, e.g. `SITE_URL=https://preview.example.com pnpm build`.
 */
const RAW_SITE_URL =
  (typeof process !== 'undefined' && process.env && process.env.SITE_URL) ||
  'https://langwatch.ai'

/** Absolute site origin, no trailing slash. */
export const SITE_URL = RAW_SITE_URL.replace(/\/+$/, '')
export const SITE_NAME = 'LangWatch'
export const TWITTER_HANDLE = '@LangWatchAi'

/**
 * Default social share image. Ideally a 1200x630 PNG per route; until those
 * exist we fall back to the brand logo. See dev/seo.md for the follow-up.
 */
export const DEFAULT_OG_IMAGE = '/logo-white.png'

/** Make a site-relative path absolute against SITE_URL. Leaves full URLs as-is. */
export function absoluteUrl(pathOrUrl: string): string {
  if (/^https?:\/\//.test(pathOrUrl)) return pathOrUrl
  return SITE_URL + (pathOrUrl.startsWith('/') ? pathOrUrl : '/' + pathOrUrl)
}
